export class Guid {
  static s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  static generate() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  static s3(step: number): string {
    const startCode: number = '0Aa'.charCodeAt(0);
    const endCode: number = '9Zz'.charCodeAt(2);

    let s3 = '';
    for (let i = startCode; i <= endCode; i++) {
      if (
        (i >= '0'.charCodeAt(0) && i <= '9'.charCodeAt(0)) ||
        (i >= 'A'.charCodeAt(0) && i <= 'Z'.charCodeAt(0)) ||
        (i >= 'a'.charCodeAt(0) && i <= 'z'.charCodeAt(0))
      ) {
        s3 += String.fromCharCode(i);
      }
    }
    const s: number = step < 2 ? 0 : (s3.length / step) * (step - 1);
    return s3.substring(s).trim().split(' ').join('');
  }

  /**
   * Always generate same string
   */
  static generateS3(): string {
    return this.s3(4) + '-' + this.s3(6) + '-' + this.s3(2) + '-' + this.s3(3);
  }
}
